 "use strict";
var React = require('react')
var Link = require('react-router')
var LanguageStore = require('../../store/LanguageStore')
var DocMeta = require('react-doc-meta');
var Proizvodi = React.createClass({
  componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
    componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },

  render() {

    return (
           this.state.lang === 'uk' ? this.eng() : this.state.lang === 'rs' ? this.srb() : this.state.lang === 'de' ? this.ger() : null
    )
  },
  srb(){
      document.title = 'Proizvodi | Termovent SC Livnica čelika A.D. Bačka Topola'
      var tags = [
      {name: "description", content: "Livnica se bavi livenjem isključivo čeličnih odlivaka, najrazličitijih oblika, veličina, hemijskog sastava, mehaničkih svojstava i namene. Proizvodnja je sertifikovana sistemom kvaliteta ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, AD 2000."},
      {name: "keyword", content: "Termovent,celik,livnica,odlivak,proizvodi,kucista,pumpe,radna kola,ventili,puzevi,odlivci, backa topola, srbija"},
      {itemProp: "name", content: "Proizvodi | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {itemProp: "description", content: "Livnica se bavi livenjem isključivo čeličnih odlivaka, najrazličitijih oblika, veličina, hemijskog sastava, mehaničkih svojstava i namene. Proizvodnja je sertifikovana sistemom kvaliteta ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, AD 2000."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "Proizvodi | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:description", content: "Livnica se bavi livenjem isključivo čeličnih odlivaka, najrazličitijih oblika, veličina, hemijskog sastava, mehaničkih svojstava i namene. Proizvodnja je sertifikovana sistemom kvaliteta ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, AD 2000."},
      {name: "twitter:creator", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Proizvodi | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Livnica se bavi livenjem isključivo čeličnih odlivaka, najrazličitijih oblika, veličina, hemijskog sastava, mehaničkih svojstava i namene. Proizvodnja je sertifikovana sistemom kvaliteta ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, AD 2000."},
      {property: "og:site_name", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
    ]
    return(
           <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>PROIZVODI</h1><br/><br/>
        <p>Livnica se bavi livenjem isključivo čeličnih odlivaka, najrazličitijih oblika, veličina, hemijskog sastava, mehaničkih svojstava i namene. Proizvodnja je sertifikovana sistemom kvaliteta ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, AD 2000. Odlivci se rade u pojedinačnoj poluserijskoj i serijskoj proizvodnji, u velikom rasponu gabarita i težine. Svoju primenu nalaze u termoelektranama, mašinogradnji, cementnoj industriji, industriji građevinskog materijala, železnici, kao i u proizvodnji armature(voda,gas,nafta).
          Za potrebe svojh kupaca Termovent SC Livnica čelika AD će kvalitetno izraditi: prirubnice, lopatice, radne vođice, viličaste glave, zasune, habajuće ugaonike, jarmove, glavčine, kućišta kuglastih slavina, čaure, zaštitne segmente, remenice, spojnice, rotore, ventile, zasune, različite pumpe, prstenove, zupčanike, članke, točkove, udarne čekiće, obložne ploče, članke bagera, ozubljene letve, vatrostalne rešetke, delove koji su izloženi koroziji i kiselini visokim temperaturama do 1000 stepeni C, rostove otporne do 1200 stepeni C i još mnogo drugih proizvoda.</p>
        <h2 className='text-center col-md-12'>Kućišta pumpe</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N001.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N002.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N015.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Radna kola</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N003.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N004.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N005.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Kućišta ventila, membrane</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N006.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N007.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N008.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N009.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N022.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image018.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Čekić</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N013.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image034.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Nosač zuba i zubi</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N020.jpg" />
        </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image038.jpg" />
        </div>
        </div>

        <h2 className='text-center col-md-12'>Puževi i obloge</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image042.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image040.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Ostali proizvodi</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N024.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Lančanik</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rosnice</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N011.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Članak lopatice</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N012.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Nož</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Lopatica</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N016.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Koturača</li>
                  </ul>
              </div>
          </div>
        </div>


        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N019.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Venac sa zupčanikom</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N023.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Fussione</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image030.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Kofice</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image036.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rostovi</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image046.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Segmenti - točkovi</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image008.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Ploča</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Udarna ploča</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Kardan</li>
                  </ul>
              </div>
          </div>
        </div>
      </div>
      </div>
      </DocMeta>
    )
  },
  ger(){
    document.title = 'Die Produkte | Die Termovent SC Stahlfabrik GmbH'
      var tags = [
      {name: "description", content: "Die Stahlfabrik produziert Stalgusse in unterschiedlichsten Formen, Größen, chemischen Aufbauarten und Nutzungsmoeglichkeiten. Der Produktionsvorgang wurde von dem Qualitätszertifikat ISO 9001: 2008 erfuellt."},
      {name: "keyword", content: "Termovent SC,Stahlfabrik,Stahlgusse, Serbien"},
      {itemProp: "name", content: "Die Produkte | Die Termovent SC Stahlfabrik GmbH"},
      {itemProp: "description", content: "Die Stahlfabrik produziert Stalgusse in unterschiedlichsten Formen, Größen, chemischen Aufbauarten und Nutzungsmoeglichkeiten. Der Produktionsvorgang wurde von dem Qualitätszertifikat ISO 9001: 2008 erfuellt."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:card", content: "product"},
      {name: "twitter:site", content: "@publisher_handle"},
      {name: "twitter:title", content: "Die Produkte | Die Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:description", content: "Die Stahlfabrik produziert Stalgusse in unterschiedlichsten Formen, Größen, chemischen Aufbauarten und Nutzungsmoeglichkeiten. Der Produktionsvorgang wurde von dem Qualitätszertifikat ISO 9001: 2008 erfuellt."},
      {name: "twitter:creator", content: "Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Die Produkte | Die Termovent SC Stahlfabrik GmbH"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Die Stahlfabrik produziert Stalgusse in unterschiedlichsten Formen, Größen, chemischen Aufbauarten und Nutzungsmoeglichkeiten. Der Produktionsvorgang wurde von dem Qualitätszertifikat ISO 9001: 2008 erfuellt."},
      {property: "og:site_name", content: "Die Termovent SC Stahlfabrik GmbH"},
    ]
    return(
      <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>DIE PRODUKTE</h1><br/><br/>
       <p>Die Stahlfabrik produziert Stalgusse in unterschiedlichsten Formen, Größen, chemischen Aufbauarten und Nutzungsmoeglichkeiten. Der Produktionsvorgang wurde von dem Qualitätszertifikat ISO 9001: 2008 erfuellt. Der Guss kann sowohl einmalig als auch mehrfach produziert werden. Dabei kann man auch Gewicht und Groesse bestimmen. Diese Gussformen koennen in thermischen Kraftwerken, im Maschinenbau, der Zementindustrie, Baustoffwirtschaft, Eisenbahn und Bewerungsproduktion (Wasser, Gas, Öl) benutzt werden.</p>

      <h2 className='text-center col-md-12'>Pump Housing</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N001.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N002.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N015.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Impellers</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N003.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N004.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N005.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Valve Body, Valve Bonnet</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N006.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N007.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N008.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N009.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N022.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image018.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Hammer</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N013.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image034.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Teeth Holder</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N020.jpg" />
        </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image038.jpg" />
        </div>
        </div>

        <h2 className='text-center col-md-12'>Snail</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image042.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image040.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Other products</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N024.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Sprocket</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rosnice</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N011.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Ankle for Blades</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N012.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Knife</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Paddle</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N016.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Tackle</li>
                  </ul>
              </div>
          </div>
        </div>


        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N019.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Wreath with cogwheel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N023.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Fussione</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image030.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Buckets</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image036.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rostovi</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image046.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Segments - wheels</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image008.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Panel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Impact Panel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Nebenantrieb</li>
                  </ul>
              </div>
          </div>
        </div>

      </div>
      </div>
</DocMeta>
    )
  },
  eng(){
    document.title = 'Products | Termovent SC Steal foundry J.S.C Backa Topola'
      var tags = [
      {name: "description", content: "Foundry specializes in production of steel castings, which can vary in shape, size, in chemical composition, mechanical properties and purposes.Production is certified by the quality system ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004"},
      {name: "keyword", content: "Termovent SC,Steel,foundry,casting,backa topola,serbia,housing,impelers,valve"},
      {itemProp: "name", content: "Products | Termovent SC Steal foundry J.S.C Backa Topola"},
      {itemProp: "description", content: "Foundry specializes in production of steel castings, which can vary in shape, size, in chemical composition, mechanical properties and purposes.Production is certified by the quality system ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004"},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "Products | Termovent SC Steal foundry J.S.C Backa Topola"},
      {name: "twitter:description", content: "Foundry specializes in production of steel castings, which can vary in shape, size, in chemical composition, mechanical properties and purposes.Production is certified by the quality system ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004"},
      {name: "twitter:creator", content: "Termovent SC Steel foundry"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Products | Termovent SC Steal foundry J.S.C Backa Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Foundry specializes in production of steel castings, which can vary in shape, size, in chemical composition, mechanical properties and purposes.Production is certified by the quality system ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004"},
      {property: "og:site_name", content: "Termovent SC Steel foundry J.S.C"},
    ]
    return(
      <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>PRODUCTS</h1><br/><br/>
       <p>Foundry specializes in production of steel castings, which can vary in shape, size,  in chemical composition, mechanical properties and purposes.Production is certified by the quality system ISO 9001:2008, OHSAS 18001:2007, ISO 14001:2004, QM System according to EN 764-5, Par. 4.2 and AD 2000-Merkblatt W 0. Castings are made in a single pole series and series production in a wide range of dimensions and weight. Foundry is engaged in production of steel castings, which can vary in shape, size,  in chemical composition, mechanical properties and purposes</p>

        <h2 className='text-center col-md-12'>Pump Housing</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N001.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N002.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N015.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Impellers</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N003.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N004.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N005.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Valve Body, Valve Bonnet</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N006.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N007.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N008.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N009.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N022.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image018.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Hammer</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N013.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image034.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Teeth Holder</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N020.jpg" />
        </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image038.jpg" />
        </div>
        </div>

        <h2 className='text-center col-md-12'>Snail</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image042.jpg" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image040.jpg" />
          </div>
        </div>

        <h2 className='text-center col-md-12'>Other products</h2>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N024.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Sprocket</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rosnice</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N011.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Ankle for Blades</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N012.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Knife</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Paddle</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N016.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Tackle</li>
                  </ul>
              </div>
          </div>
        </div>


        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N019.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Wreath with cogwheel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image-N023.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Fussione</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image030.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Buckets</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image036.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Rostovi</li>
                  </ul>
              </div>
          </div>
        </div>





        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image046.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Segments - wheels</li>
                  </ul>
              </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image008.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Panel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image010.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">Impact Panel</li>
                  </ul>
              </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="thumbnail proizvod">
            <img src="img/proizvodi/image014.jpg" />
              <div className="caption text-center">
                  <ul className="list-group text-center proizvodList">

                    <li className="list-group-item">PTO</li>
                  </ul>
              </div>
          </div>
        </div>

      </div>
      </div>
      </DocMeta>
    )
  }
})

module.exports = Proizvodi;



/** WEBPACK FOOTER **
 ** ./modules/components/Proizvodi/Proizvodi.js
 **/